import { ApiFormViewScaleOption } from "@/types/forms/form-view.types.ts";
import {
  Box,
  Button,
  EmojiDisplay,
  Stack,
  Text,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@skailer-com/uikit";

interface ScaleOptionButtonsProps {
  scale: ApiFormViewScaleOption[];
  selectedIds: number[];
  direction: "horizontal" | "vertical";
  onSelect?: (id: number) => void;
  error?: string;
}

export const ScaleOptionButtons = ({
  scale,
  selectedIds,
  direction,
  onSelect,
  error,
}: ScaleOptionButtonsProps) => {
  return (
    <Stack>
      <Stack direction={direction} className="justify-evenly" gap="xs">
        {scale.map((item) => {
          const button = (
            <Button
              size="lg"
              variant={selectedIds.includes(item.id) ? "primary" : "secondary"}
              onClick={onSelect ? () => onSelect(item.id) : undefined}
              className={direction === "horizontal" ? "px-1" : ""}
            >
              {item.emoji && <EmojiDisplay size="xl" id={item.emoji} />}
              {item.title && !item.emoji && <Text>{item.title}</Text>}
            </Button>
          );
          const description = item.description?.trim();

          return (
            <Stack
              key={item.id}
              gap="xs"
              className={direction === "horizontal" ? "flex-1 grow" : ""}
            >
              {description ? (
                <Tooltip>
                  <TooltipTrigger asChild>{button}</TooltipTrigger>
                  <TooltipContent>{description}</TooltipContent>
                </Tooltip>
              ) : (
                button
              )}
              {item.title && item.emoji && <Text className="self-center">{item.title}</Text>}
            </Stack>
          );
        })}
      </Stack>
      {error && (
        <Box className="pt-2 pb-4">
          <Text className="text-danger">{error}</Text>
        </Box>
      )}
    </Stack>
  );
};
